import React, { useEffect, useState } from 'react'
import { Button, Header } from 'sfy-react'

import SessionTimeoutIcon from '../../../../assets/images/session-timeout.svg'
import './SessionTimeout.scss'

const SessionTimeout = () => {
  const [timer, setTimer] = useState(5)
  const handleRedirectToLogin = () => {
    localStorage.clear()
    window.location.href = '/login'
  }

  useEffect(() => {
    let timerInterval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1)
    }, 1000)

    setTimeout(() => {
      localStorage.clear()
      window.location.href = '/login'
    }, 5000)

    return () => {
      clearInterval(timerInterval)
    }
  }, [])

  return (
    <>
      <Header
        className={{ header: 'logo p0 pl20 pr20', navLink: 'header-item' }}
        iconType='svg'
        brand={
          <img src={`/${window.appName}/images/servify_logo.svg`} className={`sidebar-image`} onClick={() => handleRedirectToLogin()} alt='logo' />
        }
      />
      <div className='session-timeout-container'>
        <img src={SessionTimeoutIcon} width='200px' alt='Session Timeout' />
        <div style={{ fontFamily: 'Hellix-SemiBold', fontSize: '45px' }} className='mt30'>
          Session Timeout
        </div>
        <div style={{ textAlign: 'center', fontSize: '16px', marginTop: '10px' }}>
          Your session has expired.
          <br />
          {`You will be redirected to the login page in 00:0${timer} seconds or click here to log in now.`}
          <div className='mt20'>
            <Button handleOnClick={handleRedirectToLogin} type='button' text='Login Again' classes='button-primary timeout-btn' />
          </div>
        </div>
      </div>
    </>
  )
}

export default SessionTimeout
